<form autocomplete="off" [formGroup]="form" class="d-flex">

  @if (!field.Fields || field.Fields.length === 0) {
    <div>
      This request has no body.
    </div>
  }

  <div class="forms-container">
    @for (field of field.Fields; track field) {
      @if (form.get(field.Name)) {
        <eva-ui-editor-element [field]="field" [isArray]="false" [formControlName]="field.Name"></eva-ui-editor-element>
      }
    }
  </div>
</form>
